import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    loader: false,
    loadingImages: []
};

const systemSlice = createSlice({
    name: "system",
    initialState,
    reducers: {
        addImageToLoading(state, action) {
            if (state.loadingImages.indexOf(action.payload) === -1){
                state.loadingImages.push(action.payload);
                state.loader = true;
            }
        },
        removeImageFromLoading(state, action) {
            state.loadingImages = state.loadingImages.filter((value) => (value !== action.payload));
            if (state.loadingImages.length < 1)
                state.loader = false;
        },
        showLoader(state, action) {
            state.loader = action.payload;
        }
    }
});

export const {
    addImageToLoading,
    removeImageFromLoading,
    showLoader
} = systemSlice.actions;

export default systemSlice.reducer;